import React, {useEffect, useRef, useState} from 'react'
import {Icon, Modal, Popover, Row} from "antd";
import Col from "antd/es/grid/col";
import Button from "antd/es/button";
import {Images} from "../../Helpers/Images";
import CounterComponent from "../../Components/PageComponents/Public/HomePage/CounterComponent";
import Slider from "react-slick";
import {FaChevronRight, FaChevronLeft, FaChild} from 'react-icons/fa'
import Loading from "../../Components/Generic/Loading";
import {BiRefresh, FaWheelchair} from "react-icons/all";
import moment from "moment/moment";
import {globalMaskReal} from "../../Helpers/Functions";
import InfiniteScroll from "../Components/InfiniteScroll";
import {Env} from "../../Helpers/Env";
import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import useApi from "../../Hooks/Api";
import filters from "postcss-safe-parser/lib/safe-parser";
import {eventVisible} from "../../Hooks/Helpers";
import RegisterPageModal from "../RegisterPageModal";
import BannerApps from "../../Components/PageComponents/Public/HomePage/BannerAps";
import childbg from "../../Img/aprendiz/bgbanner.jpeg";
import useAuth from "../../Hooks/Auth";

export const LandingApprenticePage = () => {
  const [opportunities, setOpportunities] = useState([]);
  const user = useSelector((state) => state).authReducer;
  const api = useApi();
  const history = useHistory();
  const qtdOp = useRef({});
  const [registerModal, setRegisterModal] = useState(false);
  const [searchTypeModal, setSearchTypeModal] = useState(false);
  const {isLogged, getUser} = useAuth();

  //Vacancy
  const activeOpportunity = useRef(null);
  //DRAWERS
  const [showDetails, setShowDetails] = useState(false)

  //LOADINGS
  const [loading, setLoading] = useState(true);
  const [loadingOpportunity, setLoadingOpportunity] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false)


  const filters = useRef({})
  const pageController = useRef({})


  const getData = (more) => {
    let payload = filters.current
    more ? setLoadingMore(true) : setLoading(true);

    if (more) {
      if (pageController.current.next_page) {
        payload.page = pageController.current.page + 1
      }
    } else {
      payload.page = 1
      if (Object.keys(pageController.current).length > 0) {
        pageController.current = {}
      }
    }
    let idVacancy = window.queryStringToObject()?.id || null

    if (window.location.pathname.includes('/vagas-do-evento')) payload.event = Env.event_name

    let qs = window.objectToQueryString(payload)

    if(idVacancy) qs = `${qs}&id=${idVacancy}`;

    payload.job_type = 'Aprendiz';

    history.push(`${window.location.pathname}${qs}`)
    api.get(`sine/search_opportunities${window.objectToQueryString(payload, true)}`, (res) => {
      let aux;
      pageController.current = {
        next_page: res.next_page,
        page: res.page,
        is_my_applications: false
      }

      if (more) {
        aux = opportunities.concat(res.opportunities);
      } else {
        aux = res.opportunities
      }

      qtdOp.current.total_jobs_openings = res.total_job_openings;
      setOpportunities(aux)
      more ? setLoadingMore(false) : setLoading(false);
    }, (e) => {
      console.log(e);
    });
  };

  const infiniteScroll = () => {
      if (pageController.current.next_page === true) {
        getData(true)
      }
  }

  const getOpportunity = (id, index, candidate) => {
    activeOpportunity.current = null;
    setShowDetails(true);
    setLoadingOpportunity(true);
    api.get(user?.user_id ? `sine/user/${user.user_id}/job-opportunity/${id}` : `/sine/job-opportunity/${id}`, (res) => {

      if (res.desired_skills_categories !== null) {
        res.desired_skills_categories?.forEach(el => res.desired_skills.push(el.title))
      }

      if (res.incentives_categories !== null) {
        res.incentives_categories?.forEach(el => res.incentives.push(el.title))
      }

      activeOpportunity.current = res;
      activeOpportunity.current.id = id;
      activeOpportunity.current.index = index;
      activeOpportunity.current.is_candidate = candidate;
      setLoadingOpportunity(false);
    }, (e) => {
      console.log(e)
      setLoadingOpportunity(false);
      setShowDetails(false);
    });
  };

  const formatIncentives = (item) => {
    let aux = [];


    for (let i = 0; i < item.incentives?.length; i++) {
      if (aux.length < 3) {
        aux.push(
            <div style={{
              display: "flex",
              alignItems: "center",
              flexWrap: 'wrap',
              minHeight: 25,
              backgroundColor: '#34c38f2e',
              borderRadius: 4,
              textAlign: "center",
              padding: 6,
              fontSize: 12,
              lineHeight: 1
            }}>
              <span style={{fontWeight: 500, color: '#34c38f'}}>{item.incentives[i]}</span>
            </div>
        );
      } else {
        break;
      }
    }

    for (let y = 0; y < item.incentives_categories?.length; y++) {
      if (aux.length < 3) {
        aux.push(
            <div style={{
              display: "flex",
              alignItems: "center",
              flexWrap: 'wrap',
              minHeight: 25,
              backgroundColor: '#34c38f2e',
              borderRadius: 4,
              textAlign: "center",
              padding: 6,
              fontSize: 12,
              lineHeight: 1
            }}>
              <span style={{fontWeight: 500, color: '#34c38f'}}>{item.incentives_categories[y].title}</span>
            </div>
        )
      } else {
        break;
      }
    }


    if ((item?.incentives_categories?.length + item.incentives?.length) > 3) {
      aux.push(<div style={{
        display: "flex",
        alignItems: "center",
        flexWrap: 'wrap',
        minHeight: 25,
        backgroundColor: '#34c38f2e',
        borderRadius: 4,
        textAlign: "center",
        padding: 6,
        fontSize: 12,
        lineHeight: 1
      }}>
        <span style={{fontWeight: 500, color: '#34c38f'}}>...</span>
      </div>)
    }
    return aux;
  };

  const openOpportunity = (id, b, c) => {
    const queryString =  window.queryStringToObject()
    queryString.id = id;

    const urlParams = new URLSearchParams(queryString);
    if (eventVisible() && window.location.pathname.includes("vagas-do-evento")) {
      history.push(`/vagas-do-evento?${urlParams}`)
    } else {
      history.push(`/vagas-de-emprego?${urlParams}`);
    }
    getOpportunity(id, b, c);
  }

  useEffect(() => {
    getData();
  },[])

  return (
      <Row className='landing-page' style={{backgroundColor: "#f8f9fc"}}>
        <Modal footer={null} visible={searchTypeModal} onCancel={() => setSearchTypeModal(false)}>
          <Row gutter={[12,12]} style={{margin: 0, width: '100%', display: 'flex', flexWrap: 'wrap', alignItems: 'stretch'}}>
            <Col xs={24} md={24} lg={12} >
              <div className='regTypeCards' style={{background: 'none', boxShadow: 'none'}}>
                <div style={{width: '100%'}}>
                  <img style={{maxHeight: '300px', maxWidth: '100%', marginBottom: 20}} src={Images.step3vacancy}/>
                </div>

                <div style={{textAlign: 'left', flex: 1, display: 'flex', flexFlow: 'column', justifyContent: 'space-around'}}>
                  <div>
                    <h3 className={'primary-sub-color'} >Buscar manualmente</h3>
                  </div>
                  Quero buscar currículos de Aprendiz manualmente
                </div>
                <Button className={'ant-btn-sub-primary'} style={{ marginTop: 20}} onClick={() => {history.push('/curriculos')}}> <span style={{color: 'white'}}> Buscar </span> </Button>

              </div>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <div className='regTypeCards' style={{background: 'none', boxShadow: 'none'}}>
                <div style={{width: '100%'}}>
                  <img style={{maxHeight: '300px', maxWidth: '100%',  marginBottom: 20}} src={Images.step2vacancy}/>
                </div>
                <div style={{textAlign: 'left', flex: 1, display: 'flex', flexFlow: 'column', justifyContent: 'space-around'}}>
                  <div>
                    <h3 style={{color: '#dec781'}} >Divulgar vaga para Aprendiz </h3>
                  </div>
                  Quero divulgar uma vaga de emprego para aprendizes
                </div>
                <Button className={"ant-btn"}  onClick={() => {setRegisterModal('login')}} style={{marginTop: 20, borderColor: '#dec781', backgroundColor: '#dec781'}}> <span style={{color: 'white'}}> Divulgar </span>  </Button>

              </div>
            </Col>

          </Row>
        </Modal>
        <RegisterPageModal profile={''} visible={registerModal} type={registerModal} setVisible={() => setRegisterModal(false)} />

        <Row style={{minHeight:500, alignItems: "end"}} className='d-flex flex-wrap justify-content-between bg-header'>
          <Col md={12} lg={12} style={{padding:'2rem', zIndex: 2, marginTop: "auto", marginBottom: 'auto', position:"relative"}} className={`main-title ${window.innerWidth <= 450 ? 'text-center' : 'text-unset'}`}>
            <h1 style={{marginBottom:12, color:'white', fontWeight:700}} className='text-primary'>
              Recrutamento e seleção de Aprendizes
            </h1>
            <p className='text-white'>
              Encontre e divulgue vagas para Aprendiz
            </p>
            <Col xs={24} md={14} lg={12} xl={8} style={{height:50}}>
              <div style={{display: 'flex', alignItems: 'center',}}>
                <Button className='btn-header ' style={{padding: 10, marginRight: 10}} onClick={() => isLogged() ? history.push('/painel/cliente/vagas') : setRegisterModal('login')}>
                  <span className='text-white'>Anunciar vagas </span>
                </Button>

                <Button className='btn-header ant-btn-green-gradient' style={{padding: 10}} onClick={() => history.push('/vagas-de-emprego?job_type=Aprendiz')}>
                  <span className='text-white'>Buscar Vagas </span>
                </Button>
              </div>

            </Col>
          </Col>
          <Col md={12} lg={8} style={{zIndex: 2,}}>
            <img className='w-100' src={Images.aprendiz.aprendiz}/>
          </Col>
          <img style={{position: "absolute", zIndex: 1, height: '100%'}} src={Images.aprendiz.aprendizBg}/>
        </Row>

        <Row style={{marginTop:'4rem'}} className='d-flex justify-content-center'>
            <Col  xs={24} sm={24} md={24} lg={22} xl={20} xxl={17}>
              <Row className='d-flex justify-content-center align-items-center flex-column service-title'>
                <h4 className='text-uppercase'>PARTICIPE DO MERCADO DE APRENDIZ</h4>
                <div>
                  <img src={Images.lineLanding}/>
                </div>
                <p className='text-center'>
                  No {Env.application_title} você encontra o maior mercado de Aprendizes do Estado de Rondônia de forma fácil, rápida e gratuita!
                </p>
              </Row>
              <Row className='d-flex flex-wrap'>
                <Col xs={24} md={12} lg={12} className='service-box' style={{cursor:'pointer'}} onClick={() => history.push('/vagas-de-emprego?job_type=Aprendiz')}>
                  <div className='p-1'>
                    <div className='service-icon'>
                      <img style={{height:54, width:54}} src={Images.publishLanding}/>
                    </div>
                    <div className='service-title'>
                      <h4>Encontre vagas de emprego para aprendiz e cadastre seu currículo</h4>
                      <p className='text-justify'>
                        Encontre vagas de emprego para Aprendiz utilizando filtros avançados para refinar sua busca e facilitar a seleção de oportunidades.
                      </p>
                    </div>
                  </div>
                </Col>

                <Col xs={24} md={12} lg={12} className='service-box'>
                  <div className='p-1' style={{cursor: 'pointer'}} onClick={() => setSearchTypeModal(true)}>
                    <div className='service-icon'>
                      <img style={{height:54, width:54}} src={Images.searchLanding}/>
                    </div>
                    <div className='service-title'>
                      <h4>
                        Encontre currículos de aprendiz
                      </h4>
                      <p className='text-justify'>
                        Publique uma vaga para Aprendiz com requisitos detalhados, onde os usuários poderão se candidatar diretamente ou faça uma busca na nossa base de dados e encontre o perfil que se adequa à sua empresa.
                      </p>
                    </div>

                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
       {/* <Row style={{backgroundColor:'#fbfbfb', marginTop:'4rem'}}>
          <Row className='d-flex justify-content-center'>
            <Col style={{marginTop:'4rem'}} xs={24} sm={24} md={24} lg={22} xl={20} xxl={17}>
              <Row  className='d-flex justify-content-center text-center'>
                <Col lg={12} md={14} className='service-title'>
                  <h4 className='text-uppercase'>
                    Quem somos nós
                  </h4>
                  <div>
                    <img src={Images.lineLanding}/>
                  </div>
                  <p>
                    Plataforma de empregabilidade totalmente gratuita oferecida pelo Governo do Estado do Mato Grosso do Sul em parceria com a FUNTRAB.
                  </p>
                </Col>
              </Row>
              <Row style={{gap:8}} className='d-flex justify-content-center align-items-center flex-wrap'>
                <Col xs={20} md={10} lg={8}>
                  <img className='w-100' src={Images.aboutLanding}/>
                </Col>

                <Col xs={20}  md={12} lg={9} className='d-flex flex-column service-title offset-lg-1'>
                  <h2>
                    Nosso objetivo é promover a empregabilidade no estado de Mato Grosso do Sul, fazendo o papel de conectar as empresas aos trabalhadores mais qualificados para elas.
                  </h2>
                  <p className='text-justify'>
                    Desde dezembro de 2020, o MS Contrata Mais trabalha para ter o máximo de trabalhadores contratados para as empresas que disponibilizam vagas, sempre otimizando nossa plataforma e atribuindo novas funcionalidades que melhor atendem às necessidades de nossos usuários.
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Row>*/}

        <Row style={{padding: 40}}>
          <div style={{color: '#212529', marginBottom: 10, padding: '0 10px'}}>
            <h1 style={{fontSize: 20, fontWeight: 300}}>Mostrando <span
                style={{fontWeight: 600}}>{qtdOp.current?.total_jobs_openings}</span> vagas </h1>
          </div>
          {loading ?
              <div style={{margin: '20px 0'}}>
                <Loading/>
              </div> :
              <div className={`d-flex flex-wrap ${loadingMore ? 'opacity-loading' : ''}`}>
                {opportunities?.map((item, index) =>
                    <Col xs={24} md={12} lg={12} xl={8} key={index}
                         onClick={() => openOpportunity(pageController.current.is_my_applications ? item.opportunity_id : item.id, index, item.is_candidate)}
                         style={{padding: 10,}}>
                      <div className={'vacancyHover'}
                           style={{display: "flex", justifyContent: "space-between", flexDirection: "column"}}>
                        <div>
                          <div className='d-flex justify-content-between'
                               style={{marginTop: 5, height: 20}}>


                            <div className='d-flex flex-column'>
                                                      <span
                                                          style={{
                                                            flex: 1,
                                                            letterSpacing: 1,
                                                            fontSize: 12,
                                                            color: '#9e9e9e'
                                                          }}>
                                                        {item.work_place === 'mobile' ? "Trabalho remoto/Home office" : (item.work_place === 'itinerant' ? "Sem endereço fixo" : (item.work_address ? item.work_address.city : null))}
                                                    </span>

                              {item?.postponed && <span style={{color: '#03A9F4', fontSize: 12}}>
                                                        <BiRefresh style={{fontSize: 13, marginBottom: -2}}/>
                                                        <span> Inscrições adiadas</span>
                                                    </span>}
                            </div>
                            <span style={{
                              textAlign: 'right',
                              flex: 1,
                              fontSize: 12,
                              color: '#9e9e9e'
                            }}>
                                                        Publicado em {moment(item.start_date, 'YYYY-MM-DD').format('DD/MM')}
                                                    </span>
                          </div>

                          <div style={{display: "flex", justifyContent: "flex-end"}}>
                            {item.job_type.includes("Aprendiz") &&
                                <div style={{padding: "5px"}}>
                                  <Popover content={'Vaga para jovem aprendiz'}>
                                    <FaChild/>
                                  </Popover>
                                </div>
                            }
                            {item.disabilities_opt &&
                                <div style={{padding: "5px"}}>
                                  <Popover content={'Vaga para PcD (Pessoa com deficiência)'}>
                                    <FaWheelchair/>
                                  </Popover>
                                </div>
                            }
                          </div>
                          {item.is_candidate && <img style={{
                            position: 'absolute',
                            right: 20,
                            opacity: 0.1,
                            bottom: 20,
                            width: 80,
                            height: 80
                          }} src={Images.checked}/>}
                          <div className='de-flex flex-column' style={{height: 250}}>
                            <div className='d-flex flex-column align-items-center'
                                 style={{minHeight: 50}}>
                              <div>
                                <img style={{
                                  backgroundColor: 'white',
                                  width: 60,
                                  borderRadius: 5
                                }} src={item.job_avatar ? item.job_avatar : Images.case_img}/>
                              </div>
                              <div style={{
                                fontWeight: 'bold',
                                fontSize: 16,
                                paddingTop: 10,
                                textAlign: "center"
                              }}>
                                {item.occupation_title ? item.occupation_title : item.occupation_name}
                              </div>

                            </div>
                            <div className='d-flex align-items-center justify-content-between'
                                 style={{gap: 16, minHeight: 30}}>
                              <div>
                                <span style={{color: 'green', fontWeight: "bold"}}>R$</span>
                                <span style={{
                                  fontSize: 13,
                                  color: 'green'
                                }}> {item.pay ? globalMaskReal(item.pay) : 'Não Informado'} </span>
                              </div>
                              {item.job_type.length > 0 &&
                                  <div>
                                    <Icon color={'grey'} type={'clock-circle'}/>
                                    <span style={{
                                      fontSize: 14,
                                      color: 'grey',
                                      marginLeft: 5,
                                    }}>{item.job_type[0]} </span>
                                  </div>
                              }
                              <span style={{fontSize: 14, color: 'grey'}}><span
                                  style={{fontWeight: 'bold'}}>{item.job_openings}</span> Vaga(s) </span>
                            </div>
                            {item.is_candidate &&
                                <div className='d-flex justify-content-between'>
                                  <div style={{alignItems: 'center', flex: 1,}}>
                                    <Icon color={'grey'} size={15} name={'check-all'}/>
                                    <span style={{
                                      fontSize: 14,
                                      fontWeight: 'bold',
                                      color: 'grey',
                                      flex: 1,
                                    }}>CURRÍCULO ENVIADO </span>
                                  </div>
                                </div>
                            }
                            {(item.incentives.length > 0 || item.incentives_categories?.length > 0) &&
                                <Col span={24} className='d-flex flex-wrap justify-content-center'
                                     style={{padding: '10px 0', gap: 2, fontSize: 10, minHeight: 40}}>
                                  {formatIncentives(item)}
                                </Col>
                            }
                          </div>

                          {item.job_description && (
                              <div style={{
                                borderTop: '1px solid gainsboro',
                                width: '100%',
                                wordBreak: 'break-word',
                                borderTopColor: 'gainsboro',
                                paddingTop: 10,
                                textAlign: "justify"
                              }}>
                                                    <span className={'limit-rows clamp-3'} style={{
                                                      color: '#808080c7',
                                                      fontSize: 13,
                                                    }}>{item.job_description} </span>
                              </div>)
                          }
                        </div>

                        {/*{item.end_date &&*/}
                        {/*    <div style={{margin:"8px 0"}}>*/}
                        {/*        <ExpirationBadge date={item.end_date}/>*/}
                        {/*    </div>*/}
                        {/*}*/}
                      </div>
                      {(!loading && opportunities.length - 3 === index) &&
                          <div>
                            <InfiniteScroll paginate={filters.current}
                                            fetchMore={() => !loadingMore && infiniteScroll()}
                            />
                          </div>
                      }
                    </Col>
                )}
              </div>
          }
        </Row>

        {/*<Row style={{marginTop: '4rem'}} className='d-flex justify-content-center'>
          <Col className='d-flex flex-column justify-content-center' xs={24} sm={24} md={24} lg={22} xl={20} xxl={17}>
            <Row className='service-title text-center text-uppercase'>
              <h4>Clientes que usam o MS Contrata+</h4>
            </Row>
            <div className='text-center'>
              <img src={Images.lineLanding}/>
            </div>
            <Row className='d-flex justify-content-between align-items-center flex-wrap'>
              <div>
                <img style={{height:100}} src={Images.americanas} alt="Logo Americanas"/>
              </div>
              <div>
                <img style={{height:100}} src={Images.anita} alt="Logo Anita"/>
              </div>
              <div>
                <img style={{height:100}} src={Images.cometa} alt="Logo Cometa"/>
              </div>
              <div>
                <img style={{height:100}} src={Images.girafas} alt="Logo Girafas"/>
              </div>
              <div>
                <img style={{height:100}} src={Images.safari} alt="Logo Safari"/>
              </div>
              <div>
                <img style={{height:100}} src={Images.niura} alt="Logo Safari"/>
              </div>
            </Row>
          </Col>
        </Row>*/}
        <BannerApps/>
      </Row>

  )
}
